import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import styled from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

import {RelativeFilterResponseBody} from '../../../../../types/api/api';
import {PresetListItem} from './PresetListItem';

interface SortablePresetListItemProps extends TestIdProps {
  preset: RelativeFilterResponseBody;
  isSelected: boolean;
  onSelect: (presetId: string) => void;
}

export function SortablePresetListItem(props: SortablePresetListItemProps) {
  const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({
    id: props.preset.id,
  });

  return (
    <SortableRow
      ref={setNodeRef}
      $transform={CSS.Transform.toString(transform) ?? undefined}
      $transition={transition ?? undefined}
      $isDragging={isDragging}
    >
      <PresetListItem
        preset={props.preset}
        isSelected={props.isSelected}
        isSortable
        dragHandleAttributes={attributes}
        dragHandleListeners={listeners}
        onSelect={props.onSelect}
        data-testid={suffixTestId(`preset-${props.preset.id}`, props)}
      />
    </SortableRow>
  );
}

const SortableRow = styled.div<{
  $transform: string | undefined;
  $transition: string | undefined;
  $isDragging: boolean;
}>`
  transform: ${({$transform}) => $transform};
  transition: ${({$transition}) => $transition};
  opacity: ${({$isDragging}) => ($isDragging ? 0.5 : 1)};
`;
